import { PRINT_DOTS, toMonochrome, trimBottom } from '@makila/pos-core';

/** Largura útil (mm) por papel: o que a cabeça térmica imprime. */
const PRINTABLE_MM = { 80: 72, 58: 48 } as const;

/**
 * Desenha o HTML de um talão (o mesmo que vai à impressão do sistema) numa
 * imagem a 1 bit com a largura da cabeça da impressora. Mede-o num iframe
 * escondido e desenha-o num canvas por SVG/foreignObject — tudo local, sem
 * rede nem bibliotecas: os tipos de letra são os do sistema.
 */
export async function htmlToBitmap(html: string, paper: 58 | 80) {
  const mm = PRINTABLE_MM[paper];
  const f = document.createElement('iframe');
  f.setAttribute('aria-hidden', 'true');
  f.style.cssText = `position:fixed;left:-10000px;top:0;width:${mm}mm;height:10px;border:0;visibility:hidden`;
  document.body.appendChild(f);
  try {
    const d = f.contentDocument!;
    d.open();
    // A largura útil é a da cabeça; 1 mm de folga de cada lado (há cabeças que perdem a borda).
    d.write(html.replace('</head>', `<style>html,body{background:#fff}body{width:${mm}mm!important;padding-left:1mm!important;padding-right:1mm!important}</style></head>`));
    d.close();
    await d.fonts?.ready;
    const w = d.body.scrollWidth, h = Math.max(d.documentElement.scrollHeight, d.body.scrollHeight);
    const xhtml = new XMLSerializer().serializeToString(d.documentElement);
    const dots = PRINT_DOTS[paper];
    const scale = dots / w;
    const H = Math.ceil(h * scale);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${dots}" height="${H}" viewBox="0 0 ${w} ${h}"><foreignObject x="0" y="0" width="${w}" height="${h}">${xhtml}</foreignObject></svg>`;
    const img = new Image();
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    await img.decode();
    const c = document.createElement('canvas');
    c.width = dots; c.height = H;
    const g = c.getContext('2d', { willReadFrequently: true })!;
    g.fillStyle = '#fff'; g.fillRect(0, 0, dots, H);
    g.drawImage(img, 0, 0, dots, H);
    return trimBottom(toMonochrome(g.getImageData(0, 0, dots, H).data, dots, H));
  } finally {
    f.remove();
  }
}
